import { useExtensionGate, useRestoredSession } from "@prostocheck/data-web";

/**
 * Every hook that runs in the background with nothing of its own to render —
 * a check, a watcher — mounts here, so the app has one place that lists them
 * instead of one `<XWatcher />` per hook scattered through `App`.
 *
 * Rendered inside both `JotaiProvider` (`useExtensionGate` writes to a jotai
 * atom — a plain hook call from `App` itself would run against jotai's
 * implicit default store instead of the one `JotaiProvider` creates for its
 * subtree) and `SessionProvider` (`useRestoredSession` reads and writes the
 * session). See ai/docs/kep-signing.md.
 */
export const BackgroundHooks = () => {
  useExtensionGate();
  useRestoredSession();

  return null;
};
